module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/design-tile-images/design-tile-03-8fc037cb0479f3af17b0bfed4269caa7.webp";